const arcgis_search_redirection = (searchInput, submitBtn, searchForm) => {
  let sInput = searchInput[0];
  let btnIcon = submitBtn[0];
  let locPath = location.pathname;
  let locOrigin = location.origin;

  // clean location path;
  let cArr = locPath.split('/');
  let bArr = cArr.filter((item) => (item.length > 0));
  let pathL = bArr.length;
  let $slug = bArr[pathL - 1];


  if (btnIcon) {
    btnIcon.addEventListener('click', function (e) {
      e.preventDefault();
      let prodSlug = '';
      // create query
      let newQuery = '';
      let inputValue = sInput.value;
      let authorTest = RegExp(/^\@/);
      let tagTest = RegExp(/^\#/);

      //has slug
      $slug = $slug === 'overview' ? '' : $slug;

      if ($slug) {
        prodSlug = `&products=${$slug}`;
      }

      if (authorTest.test(inputValue) || tagTest.test(inputValue)) {
        let searchFilter = authorTest.test(inputValue) ? 'author' : 'tag';
        let stringParam = '';
        if (searchFilter === 'author') {
          let resultArr = arcgis_object.authors.filter((author) => {
            let cleanName = inputValue.substr(1);
            if (author.name == cleanName) {
              return author;
            }
          });
          stringParam = resultArr[0]['nice_name'];
        } else if (searchFilter === 'tag') {
          let resultArr = arcgis_object.tags.filter((tag) => {
            let cleanName = inputValue.substr(1);
            if (tag.name == cleanName) {
              return tag;
            }
          });
          stringParam = resultArr[0]['slug'];
        }        

        const searchPathName = searchForm.attr('action');
        window.location.assign(`${locOrigin}${searchPathName}?s=#&${searchFilter}=${stringParam}${prodSlug}`);
      } else {
        // is not filter search
        let escInput = escape(sInput.value);

        const searchPathName = searchForm.attr('action');
        newQuery = `${locOrigin}${searchPathName}?s=#${escInput}${prodSlug}`;
        window.location.assign(`${locOrigin}${searchPathName}?s=#${escInput}${prodSlug}`);
      }


      //window.location.replace(newQuery);
    });
    sInput.addEventListener('keyup', function (e) {
      e.preventDefault();
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Trigger the button element with a click
        btnIcon.click();
      }
    });
  }
};

// v.sosew

